import { ConfirmationDialogService } from 'src/app/services/confirmation-dialog.service';
import { HttpClient } from '@angular/common/http';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Renderer2,
  SimpleChanges,
  forwardRef,
  inject
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { isEqual } from 'lodash-es';
import { v4 as uuidv4 } from 'uuid';
import { cloneDeep } from 'lodash-es';
import { Subscription } from 'rxjs';
import { ApiConstants } from 'src/app/base/api-constants';
import { GlobalConstants } from 'src/app/base/global.constants';
import { HttpBaseService } from 'src/app/base/http-base.service';
import { AppGlobalService } from 'src/app/services/app.global.service';
import { UtilService } from 'src/app/services/util.service';

import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { metaInfo } from 'src/app/STORE/selectors/applifecycle.selector';
import { getPageVariables, setQueryMapData } from 'src/app/STORE/actions/screens.actions';
import { queryMapData, setPageVariables } from 'src/app/STORE/selectors/screens.selector';
import { environment } from 'src/environments/environment';

@AutoUnsubscribe({ arrayName: 'subscriptions' })
@Component({
  selector: 'vb-query-mapping',
  templateUrl: './query-mapping.component.html',
  styleUrls: ['./query-mapping.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => QueryMappingComponent),
      multi: true
    }
  ],
  standalone: false  //NOSONAR
})
export class QueryMappingComponent implements OnInit, OnChanges, ControlValueAccessor, OnDestroy {
  private confirmationDialogService = inject(ConfirmationDialogService);
  private renderer = inject(Renderer2);
  private elementRef = inject(ElementRef);
  private store = inject(Store);
  private baseService = inject(HttpBaseService);
  private appGlobalService = inject(AppGlobalService);
  private util = inject(UtilService);
  private translate = inject(TranslateService);
  private http = inject(HttpClient);

  get isBetaAccessPrivilegeConsumable(): boolean {
    return this.appGlobalService.betaAccessPrivilegeForApp;
  }

  private modelValue: any;
  private onChange: (m: any) => void;
  private onTouched: (m: any) => void;
  private activeContextKey = '';
  @Input() element: any;
  @Input() formData: any;
  @Input() disableField = false;
  @Input() isFromModernize = false;
  @Input() currentScreen: any;
  @Input() currentNode: any = null;
  @Input() currNodeType: any = null;
  @Input() techStackData: any;
  @Input() allScreens = [];
  queryMapping: any[] = [];
  allFields: any = [];
  subscriptions: Subscription[] = [];
  allFieldsFiltered: any[] = [];
  indexedFields: any[] = [];
  appId = '';
  leftFields = '';
  rightFields = '';
  typeMisMatchMessage = '';
  leftFieldsforpageVariables = '';
  rightFieldsforpageVariables = '';
  typeMisMatchMessageforpageVariables = '';
  isLoading = false;
  initialLoad = true;
  ptFields = [];
  backupVal: any = [];
  mandatoryFilterSid = null;
  optionalFilterSid = null;
  parameterMapping: any[] = [];
  noLongerFields = '';
  warningMessage = '';
  warningMessageforpagevariables = '';
  srcKey: any = null;
  tarkey: any = null;
  srcFlds: any = [];
  srcAllFlds: any[] = [];
  filterFields: any = [];
  viewInPages = false;
  holdFilterValue = false;
  selectedParam: any = null;
  showFilterOptions = false;
  showQueryFilterOptions = false;
  holdValDis = false;
  private isStoreDataReady = false;
  // Query detail mapping
  pageVariables = [];
  queryParamMap: any = null;
  queryMapData: any;
  metaInfo: any;
  activePopupIndex: number | null = null;
  popupType: 'warning' | 'error' | null = null;
  activePopupIndexsrc: number | null = null;
  popupTypesrc: 'warning' | 'error' | null = null;
  tffieldsdata: any[] = [];
  lffieldsdata: any[] = [];
  operator = {
    plusDays: '+',
    minusDays: '-'
  };
  typeOptions: any[] = [
    {
      name: 'Value',
      value: 'value'
    },
    {
      name: 'Page Variable',
      value: 'pageVariable'
    },
    {
      name: 'Form Field',
      value: 'field'
    }
  ];
  typeOptionsForDate = [
    ...this.typeOptions,
    { name: '+ Days', value: 'plusDays' },
    { name: '- Days', value: 'minusDays' }
  ];
  typeMap = {
    '': 'Value',
    value: 'Value',
    pageVariable: 'Page Variable',
    plusDays: '+ Days',
    minusDays: '- Days',
    field: 'Form Field'
  };
  showEmptyMsg = true;
  colHeader1 = '';
  colHeader2 = '';
  btnName = '';
  dateOptions = [
    {
      label: 'Yesterday',
      value: 'yesterday'
    },
    {
      label: 'Today',
      value: 'today'
    },
    {
      label: 'Tomorrow',
      value: 'tomorrow'
    }
  ];
  ynOptions = [
    {
      name: 'Yes',
      value: 'yes'
    },
    {
      name: 'No',
      value: 'no'
    }
  ];

  get model() {
    return this.modelValue;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
    // this.disabled = isDisabled;
  }

  writeValue(value: any): void {
    this.modelValue = cloneDeep(value);
    if (value && Array.isArray(value) && value.length > 0) {
      this.backupVal = cloneDeep(value);
      this.noLongerPopup(this.backupVal);
      // If store data arrived before writeValue, re-process now with actual data
      if (this.isStoreDataReady && this.parameterMapping.length === 0) {
        this.processBackupValues();
      }
    } else {
      // No mapping configured for this instance — reset all state to prevent
      // the reused component instance from leaking data from the previous node
      this.resetComponentState();
    }
  }

  toggleErrorPopup(index: number, type: 'warning' | 'error') {
    if (this.activePopupIndex === index && this.popupType === type) {
      this.closePopup();
    } else {
      this.activePopupIndex = index;
      this.popupType = type;
    }
  }

  closePopup() {
    this.activePopupIndex = null;
    this.popupType = null;
  }

  togglePopupsrc(index: number, type: 'warning' | 'error') {
    if (this.activePopupIndexsrc === index && this.popupTypesrc === type) {
      this.closePopupsrc();
    } else {
      this.activePopupIndexsrc = index;
      this.popupTypesrc = type;
    }
  }

  closePopupsrc() {
    this.activePopupIndexsrc = null;
    this.popupTypesrc = null;
  }

  /**
   * Resets all component state to prevent data leakage between reused component instances.
   * Clears all mapping arrays, field data, and error messages when switching between
   * nodes of the same type (e.g., switching between StandardDataGrid instances).
   */
  private resetComponentState(): void {
    // Clear all mapping arrays
    this.backupVal = [];
    this.parameterMapping = [];
    this.queryMapping = [];
    // Clear field data arrays to prevent detail field selections from leaking
    this.srcAllFlds = [];
    this.allFields = [];
    this.tffieldsdata = [];
    this.lffieldsdata = [];
    this.srcFlds = [];
    this.allFieldsFiltered = [];
    this.filterFields = [];
    this.indexedFields = [];
    this.ptFields = [];
    // Clear error/warning messages to prevent stale UI notifications
    this.noLongerFields = '';
    this.warningMessage = '';
    this.warningMessageforpagevariables = '';
    this.leftFields = '';
    this.rightFields = '';
    this.leftFieldsforpageVariables = '';
    this.rightFieldsforpageVariables = '';
    this.typeMisMatchMessage = '';
    this.typeMisMatchMessageforpageVariables = '';
    // Reset the store data ready flag so validation doesn't run against stale arrays
    // on the next node navigation before fresh data arrives
    this.isStoreDataReady = false;
  }

  private getContextKey(): string {
    const currentNode = this.currentNode || this.formData?.currentNode || {};
    const pageId = this.formData?.pageName?.sid || this.formData?.detailPage?.sid || '';
    const nodeId = currentNode?.sid || currentNode?.key || currentNode?.id || '';
    return [this.element?.lookupTo || '', this.element?.name || '', pageId, nodeId].join('|');
  }

  private clearRuntimeState(): void {
    this.subscriptions.forEach((sub) => sub?.unsubscribe());
    this.subscriptions = [];
    this.closePopup();
    this.closePopupsrc();
    this.resetComponentState();
    this.modelValue = null;
  }

  isNoLongerField(field) {
    if (field) {
      this.noLongerFields += field.name + ',';
    }
  }

  getNoLongerMessage() {
    if (this.noLongerFields) {
      this.noLongerFields = this.noLongerFields.slice(0, -1);
      this.warningMessage = this.translate.instant('QV_MAP_NO_LONGER_FLD').replace('{fields}', this.noLongerFields);
      this.noLongerFields = '';
    }
  }

  noLongerPopup(value) {
    const { tftableId, lftableId } = this.extractTableIdsFromValue(value);
    
    const sub1 = this.baseService.get(ApiConstants.getFieldInfo, { tableId: lftableId }).subscribe({
      next: (lfData: any) => {
        this.lffieldsdata = lfData;
        this.fetchTableFieldsAndValidate(tftableId, value);
      },
      error: (err) => console.error(err)
    });
    this.addToSubscriptionsList(sub1);
  }

  private extractTableIdsFromValue(value: any[]): { tftableId: string; lftableId: string } {
    let tftableId = '';
    let lftableId = '';
    const relevantLookups = ['queryMapMandParams', 'queryViewMapping', 'queryMapDetParams'];
    if (!relevantLookups.includes(this.element.lookupTo)) {
      return { tftableId, lftableId };
    }

    for (const m of value) {
      if (this.element.name === 'queryMapMandParams' || this.element.name === 'detailPageMapping' || m.type === 'field') {
        tftableId = m.tableField?.tableId;
        lftableId = m.lookupField?.tableId;
      }
    }
    return { tftableId, lftableId };
  }

  private fetchTableFieldsAndValidate(tftableId: string, value: any[]): void {
    const sub = this.baseService.get(ApiConstants.getFieldInfo, { tableId: tftableId }).subscribe({
      next: (tfData: any) => {
        this.tffieldsdata = tfData;
        this.processNoLongerFieldValidation(value);
      },
      error: (err) => console.error(err)
    });
    this.addToSubscriptionsList(sub);
  }

  private processNoLongerFieldValidation(value: any[]): void {
    const deletedIds = this.collectDeletedIdsAndCheckMismatches(value);
    this.getNoLongerMessage();

    if (deletedIds.length > 0) {
      this.isLoading = true;
      this.util.handleDeletedIds(deletedIds, false, "", true, "pagemapping", () => {
        this.isLoading = false;
      });
    }

    this.showTypeMismatchConfirmationIfNeeded();
  }

  private collectDeletedIdsAndCheckMismatches(value: any[]): any[] {
    const deletedIds: any[] = [];
    const relevantLookups = ['queryMapMandParams', 'queryViewMapping'];
    if (!relevantLookups.includes(this.element.lookupTo)) {
      return deletedIds;
    }

    for (const m of value) {
      const lf = this.lffieldsdata.find((f: any) => f.sid === m.lookupField?.sid);
      if (!lf) {
        deletedIds.push(m.lookupField?.sid);
      }
      if (m.type === 'field') {
        const tf = this.tffieldsdata.find((f: any) => f.sid === m.tableField?.sid);
        if (!tf) {
          deletedIds.push(m.tableField?.sid);
        }
        if (lf && tf) {
          this.typeMismatch(lf, tf);
        }
      }
    }
    return deletedIds;
  }

  private showTypeMismatchConfirmationIfNeeded(): void {
    if (!this.leftFields || !this.rightFields) {
      return;
    }

    this.typeMisMatchMessage = this.translate.instant('PARAM_FLD_TYP')
      .replace('{field1}', this.leftFields.slice(0, -1))
      .replace('{field2}', this.rightFields.slice(0, -1));
    this.leftFields = "";
    this.rightFields = "";
    this.confirmationDialogService.confirm({
      message: this.typeMisMatchMessage,
      acceptLabel: String(this.translate.instant('OK')),
      accept: () => { /* empty */ },
      rejectVisible: false
    });
  }

  typeMismatch(lf, tf) {
    // For queryMapMandParams/queryViewMapping: lf (lookupField/LHS) is TARGET, tf (tableField/RHS) is SOURCE
    // Check if tf (source) can map to lf (target)
    if(!this.util.getSourceTypesForTarget(lf?.f_type?.toLowerCase(), GlobalConstants.paramMappDataTyp)?.includes(tf?.f_type?.toLowerCase())){
      this.leftFields += lf.name + ',';
      this.rightFields += tf.name + ',';
    }
  }

  isQueryMappingFieldNoLonger(data: any): boolean {
    if(data.tableField){
      return this.util.isFieldNoLonger(data, this.allFields,'query-mapping');
    }
    return false;
  }

  isQueryMappingFieldMismatch(data: any): boolean {
    // For queryMapMandParams/detailPageMapping/queryViewMapping: LHS (lookupField) is TARGET
    if(this.element.name==='queryMapMandParams' || this.element.name==='detailPageMapping'){
      if(this.lffieldsdata.length && this.tffieldsdata.length){
        return this.util.isFieldMismatch(data, this.lffieldsdata, this.allFields, 'query-mapping')
      }
    }
    else{
      if(data.type?.value=='field' && data.tableField && data.lookupField){
        return this.util.isFieldMismatch(data, this.lffieldsdata, this.tffieldsdata, 'query-mapping');
      }
    }
    return false;
  }

  set() {
    if (this.element.lookupTo === 'queryMapMandParams') {
      const queryMap = this.queryMapping
        ?.filter((d) => d.lookupField && (d.tableField || d.staticValue))
        .map((m) => {
          const lookupField = {
            sid: m.lookupField.sid,
            appId: m.lookupField.appId,
            tableId: m.lookupField.tableId,
            type: 'field'
          };
          let type = m.type?.value;
          let tableField: any = null,
            staticValue = null;
          switch (type) {
            case 'field':
            case 'pageVariable': {
              tableField = m?.tableField
                ? {
                    sid: m?.tableField?.sid,
                    appId: m?.tableField?.appId,
                    tableId: m?.tableField?.tableId,
                    type: type
                  }
                : null;
              break;
            }
            case 'plusDays':
            case 'minusDays': {
              staticValue = m?.staticValue ? m?.staticValue : null;
              break;
            }
            case 'value': {
              const staticVal = this.queryParamMap?.find((q) => q?.listField?.sid === m.lookupField?.sid)?.staticValue;
              if (m.staticValue === staticVal?.value) {
                staticValue = m.staticValue ? staticVal?.valueSid : null;
              } else if (m.staticValue) {
                staticValue = m?.staticValue;
                type = 'customValue';
              }
              break;
            }
            default: {
              break;
            }
          }
          if (!type) {
            tableField = {
              sid: m[this.tarkey].sid,
              tableId: m[this.tarkey].tableId ? m[this.tarkey].tableId : m[this.tarkey].f_tableId,
              appId: m[this.tarkey].appId,
              type: m[this.tarkey].type == 'pageVariable' ? m[this.tarkey].type : 'field'
            };
            const tableFieldInfo = this.allFields.find((f) => f.sid == m?.tableField?.sid);
            if (tableFieldInfo?.fkTableSid) {
              tableField = {
                ...tableField,
                fkTableSid: tableFieldInfo?.fkTableSid,
                fkId: tableFieldInfo?.fkId,
                fkAppId: tableFieldInfo?.aid
              };
            }
          }
          return (m = {
            ...m,
            ...{
              staticValue: staticValue,
              type: type,
              lookupField: lookupField,
              tableField: tableField
            }
          });
        });
      this.onChange(
        queryMap?.length ? { queryMap: queryMap, queryTblmandatoryFilterSid: this.mandatoryFilterSid } : null
      );
    } else {
      this.setMapping('queryMapping');
    }
  }

  onTypeValueChange(event, index) {
    const mappng = cloneDeep(this.queryMapping);
    mappng[index].tableField = null;
    mappng[index].staticValue = null;
    mappng[index].type = event.value;
    if (this.queryParamMap && event.value === 'value') {
      const staticVal = this.queryParamMap?.find(
        (q) => q?.listField?.sid === mappng[index].lookupField?.sid
      )?.staticValue;
      mappng[index].staticValue = staticVal?.value;
    }
    this.queryMapping = [...mappng];
    this.set();
  }

  showFilteredOptions(event, data) {
    const type = data?.lookupField?.f_type;
    const query = event.query;
    // queryMapMandParams/queryMapDetParams: LHS (lookupField) is TARGET, RHS is SOURCE
    const validTypes = this.util.getSourceTypesForTarget(type.toLowerCase(), GlobalConstants.paramMappDataTyp);
    const filterFields = this.allFields
      .filter(
        (f) =>
          f?.type !== 'pageVariable' &&
          !f.fkId &&
          validTypes?.includes(f.f_type.toLowerCase()) &&
          f.name.toLowerCase().includes(query.toLowerCase())
      )
      ?.map((fld) => {
        return { sid: fld.sid, name: fld.name, f_type: fld.f_type, tableId: fld.f_tableId, appId: fld.appId };
      });
    const filterpgVars = this.allFields.filter(
      (f) =>
        f.type === 'pageVariable' &&
        validTypes?.includes(f?.f_type.toLowerCase()) &&
        f.name.toLowerCase().includes(query.toLowerCase())
    );
    if (this.element.name === 'queryViewMapping') {
      if (data?.type?.value === 'field') {
        this.allFieldsFiltered = [...filterFields];
      } else if (data?.type?.value === 'pageVariable') {
        this.allFieldsFiltered = [...filterpgVars];
      }
    } else {
      let groupedFields: any[] = [];
      if (filterFields?.length) {
        groupedFields.push({
          name: this.translate.instant('TABLE_FIELDS'),
          items: filterFields
        });
      }
      if (this.allFields.find((f) => f.fkId)) {
        this.queryMapData?.groupedFields?.forEach((gf) => {
          if (gf.items?.length) {
            const items = gf.items.filter(
              (f) =>
                validTypes?.includes(f.f_type.toLowerCase()) &&
                f.name.toLowerCase().includes(query.toLowerCase())
            );
            if (items?.length) {
              groupedFields.push({
                name: gf.label,
                items: items
              });
            }
          }
        });
      }
      if (filterpgVars?.length) {
        groupedFields.push({
          name: this.translate.instant('PAGE_VARIABLES'),
          items: filterpgVars
        });
      }

      if (!groupedFields?.length) {
        this.allFieldsFiltered = [];
        groupedFields = [];
      }
      setTimeout(() => {
        this.allFieldsFiltered = [...groupedFields];
      }, 0);
    }
  }

  onfieldSel(event, ri) {
    const value = event;
    if (value) {
      this.set();
    }
  }

  onRowDelete(ri) {
    const mappng = cloneDeep(this.queryMapping);
    mappng[ri].tableField = null;
    this.queryMapping = [...mappng];
    this.set();
  }

  addToSubscriptionsList(subName) {
    this.subscriptions.push(subName);
  }

  formMapping() {
    const queryMapsub = this.store.select(queryMapData).subscribe((queryMap) => {
      if (queryMap) {
        this.queryMapData = cloneDeep(queryMap);
        this.isLoading = false;
        this.allFields = queryMap.fields ? [...queryMap.fields] : [];
        if (queryMap?.referredTableFields) {
          this.allFields = [...this.allFields, ...queryMap.referredTableFields];
        }
        const pgVars = queryMap.pageVariables;
        if (pgVars) {
          const srcPageVariables = pgVars?.map((pv) => {
            return this.getPageVarObject(pv);
          });
          this.allFields = [...this.allFields, ...srcPageVariables];
        }
        let tblData;
        switch (this.element.lookupTo) {
          case 'queryMapMandParams': {
            if (this.element.name === 'queryViewMapping') {
              this.ptFields = queryMap.queryViewFields;
              tblData = queryMap?.queryViewtableData;
              const parsedContent = JSON.parse(queryMap?.queryviewScreenData?.contentAttachment);
              const paramMapping = this.util.findNodeByKeyValue(parsedContent, 'type', 'grid')?.data?.properties?.parameterMappingForQueryList;
              if (paramMapping?.length) {
                this.queryParamMap = cloneDeep(paramMapping);
              }
            } else if (this.element.name === 'detailPageMapping') {
              this.ptFields = queryMap.detailPageFields;
              tblData = queryMap?.detailPagetableData;
            }
            const mapFilters = (filters, backupVal, isMandatory) => {
              return (
                filters?.split(',').map((m) => {
                  const fld: any = this.ptFields.find((f: any) => f.sid === m);
                  let tableField = null;
                  let holdFilterValue;
                  let type = { name: this.typeMap.field, value: 'field' };
                  let staticValue;
                  if (this.initialLoad && backupVal) {
                    const curr = backupVal.find((b) => b.lookupField?.sid === fld?.sid);
                    if (curr) {
                      type = curr?.type ? { name: this.typeMap[curr?.type], value: curr?.type } : type;
                      tableField = curr.tableField?.sid
                        ? { ...curr.tableField, ...this.allFields.find((f) => f.sid === curr.tableField?.sid) }
                        : null;
                      // handle for plus and minus days in query view mapping
                      if (curr.staticValue && (type.value === 'plusDays' || type.value === 'minusDays')) {
                        staticValue = curr.staticValue;
                      }
                      // handle for static value in query view mapping if it is from table field
                      // since in this case the staticValue is assigned id but it should ideally be assigned with the value
                      // this case is not needed, it's assigning the id value which is not required
                      if (curr.staticValue && type.value === 'value') {
                        staticValue = fld.staticValue?.value ? fld.staticValue?.value : null;
                      }
                      // handle for static value in query view mapping if it is overriden or custom value
                      if (curr.staticValue && type.value === 'customValue') {
                        staticValue = curr.staticValue;
                        // changing the type back to 'value' because 'customValue' is not supported in UI
                        type = { name: this.typeMap.value, value: 'value' };
                      }
                    }
                    if (this.currNodeType?.toLowerCase() === 'queryview' && !tableField && !staticValue) {
                      // check whether value is present in parameter mapping
                      if (this.queryParamMap?.length) {
                        const pmfld = this.queryParamMap.find((mp: any) => mp.listField?.sid === fld?.sid);
                        if (pmfld && pmfld.staticValue) {
                          type = { name: this.typeMap.value, value: 'value' };
                          staticValue = pmfld.staticValue?.value ? pmfld.staticValue?.value : null;
                        }
                      }
                    }
                    holdFilterValue = curr?.holdFilterValue;
                  }
                  let name = fld.name;
                  if (isMandatory) {
                    name += '*'; // Add asterisk for mandatory fields
                  }
                  let obj = {
                    lookupField: {
                      sid: fld.sid,
                      name: name,
                      f_type: fld.f_type,
                      tableId: fld.f_tableId,
                      appId: fld.appId
                    },
                    tableField: tableField,
                    holdFilterValue: holdFilterValue
                  };
                  if (this.currNodeType?.toLowerCase() === 'queryview') {
                    obj = {
                      ...obj,
                      ...{
                        holdFilterValue: holdFilterValue,
                        type: type,
                        staticValue: staticValue
                      }
                    };
                  }
                  return obj;
                }) || []
              );
            };

            let mandatoryFilters = [];
            let optionalFilters = [];

            if (tblData?.t_mandatory_filters) {
              this.mandatoryFilterSid = tblData?.t_mandatory_filters;
              mandatoryFilters = mapFilters(tblData?.t_mandatory_filters, this.backupVal, true);
            }

            if (tblData?.t_optional_filters) {
              this.optionalFilterSid = tblData?.t_optional_filters_sid;
              optionalFilters = mapFilters(tblData?.t_optional_filters, this.backupVal, false);
            }
            this.queryMapping = [...mandatoryFilters, ...optionalFilters];
            this.initialLoad = false;
            break;
          }
          case 'queryMapDetParams': {
            const sidObj = queryMap?.detailPageFields.find((field) => field.name.toLowerCase() === 'sid');
            let mappedFieldInfo,
              savedtableField: any = null;
            if (this.backupVal.length) {
              savedtableField = this.backupVal[0].tableField;
              mappedFieldInfo = this.allFields.find((field) => savedtableField?.sid === field.sid) || {
                name: this.metaInfo[savedtableField?.sid]
              };
              savedtableField = { ...savedtableField, ...{ name: mappedFieldInfo.name } };
            }
            this.queryMapping = [
              {
                lookupField: {
                  sid: sidObj.sid,
                  name: sidObj.name,
                  tableId: sidObj.f_tableId,
                  appId: sidObj.aid,
                  f_type: sidObj.f_type
                },
                tableField: savedtableField
              }
            ];
            break;
          }
          default: {
            break;
          }
        }
      }
    });
    this.addToSubscriptionsList(queryMapsub);
  }

  isParameterMappingSourceFieldNoLonger(data: any): boolean {
    if(data[this.srcKey]){
      if (!this.fieldArrayHasTable(this.srcAllFlds, data[this.srcKey])) {
        return false;
      }
      return this.util.isFieldNoLonger(data,this.srcAllFlds,'query-mapping',this.srcKey);
    }
    return false;
  }

  isParameterMappingTargetFieldNoLonger(data: any): boolean {
    if(data[this.tarkey]){
      if (!this.fieldArrayHasTable(this.allFields, data[this.tarkey])) {
        return false;
      }
      return this.util.isFieldNoLonger(data, this.allFields,'query-mapping',this.tarkey);
    }
    return false;
  }

  isParameterMappingFieldMismatch(data: any): boolean {
    if(data[this.srcKey] && data[this.tarkey]){
      // For parameterMapStdGrid/parameterMapStdGridPageVar/queryMapPageVar: LHS (srcKey) is TARGET
      const isLhsTarget = this.element.lookupTo === 'parameterMapStdGrid' || this.element.lookupTo === 'parameterMapStdGridPageVar' || this.element.lookupTo === 'queryMapPageVar';
      return this.util.isFieldMismatch(data, this.srcAllFlds, this.allFields, 'query-mapping', this.srcKey, this.tarkey, isLhsTarget);
    }
    return false;
  }

  showFlds(event, data) {
    const query = event.query;
    const sourceRestrictionConst = this.getSourceFieldRestrictionConstant();
    const srcfields = this.srcAllFlds
      .filter(
        (f: any) =>
          f?.type !== 'pageVariable' &&
          !f.fkId &&
          !this.util.isRestrictedFieldByConstants(sourceRestrictionConst, f) &&
          f.name?.toLowerCase().includes(query.toLowerCase())
      )
      ?.map((fld: any) => {
        return {
          sid: fld.sid,
          name: fld.name,
          indexed: fld.indexed,
          f_type: fld.f_type,
          tableId: fld.f_tableId,
          appId: fld.appId,
          searchable: fld.searchable
        };
      });
    const srcPageVariables = this.srcAllFlds.filter(
      (fld: any) =>
        fld?.type === 'pageVariable' &&
        !this.util.isRestrictedFieldByConstants(sourceRestrictionConst, fld) &&
        GlobalConstants.paramMappDataTyp[fld?.f_type.toLowerCase()]?.includes(fld.f_type.toLowerCase()) &&
        fld.name?.toLowerCase().includes(query.toLowerCase())
    );
    srcfields.forEach((s) => {
      if (this.indexedFields?.includes(s.sid)) {
        s.indexed = true;
      } else {
        s.indexed = false;
      }
    });
    // group for only detailPage params and hold value params
    switch (this.element.lookupTo) {
      case 'detailPageParameters':
      case 'parameterMapHoldValParams':
      case 'navigatePageParams':
      case 'parameterMapStdGrid':
        const groupedFields: any = [];
        if (srcfields?.length > 0) {
          groupedFields.push({
            name: this.translate.instant('TABLE_FIELDS'),
            items: srcfields
          });
        }
        if (this.srcAllFlds.find((f) => f.fkId)) {
          this.queryMapData?.groupedFields?.forEach((gf) => {
            if (gf.items?.length) {
              const items = gf.items
                .filter(
                  (f) =>
                    !this.util.isRestrictedFieldByConstants(sourceRestrictionConst, f) &&
                    GlobalConstants.paramMappDataTyp[f.f_type.toLowerCase()]?.includes(f.f_type.toLowerCase()) &&
                    f.name.toLowerCase().includes(query.toLowerCase())
                )
                ?.map((fld) => {
                  return {
                    sid: fld.sid,
                    name: fld.name,
                    f_type: fld.f_type,
                    tableId: fld.f_tableId,
                    appId: fld.appId,
                    searchable: this.srcAllFlds?.find((f) => fld.sid == f.sid)?.searchable
                  };
                });
              if (items?.length) {
                groupedFields.push({
                  name: gf.label,
                  items: items
                });
              }
            }
          });
        }
        if (srcPageVariables?.length > 0 && this.element.lookupTo !== 'parameterMapStdGrid') {
          groupedFields.push({
            name: this.translate.instant('PAGE_VARIABLES'),
            items: srcPageVariables
          });
        }
        if (this.element.lookupTo === 'navigatePageParams' && this.colHeader1 === 'VARFRMLST') {
          this.srcFlds = [...srcPageVariables];
        } else {
          this.srcFlds = [...groupedFields];
        }
        break;
      case 'parameterMapStdGridPageVar':
      case 'queryMapPageVar':
        this.srcFlds = [...srcPageVariables];
        break;
      default:
        break;
    }
  }

  showFilterOptsForTarget(event, srcKey) {
    const type = srcKey?.f_type;
    const query = event.query;
    // For parameterMapStdGrid/parameterMapStdGridPageVar/queryMapPageVar: srcKey (LHS) is TARGET
    // For other mappings: srcKey (LHS) is SOURCE, we filter for valid TARGETS
    const isLhsTarget = this.element.lookupTo === 'parameterMapStdGrid' || this.element.lookupTo === 'parameterMapStdGridPageVar' || this.element.lookupTo === 'queryMapPageVar';
    const targetRestrictionConst = isLhsTarget ? 'paramMappingTarget' : 'targetFields';
    const validTypes = isLhsTarget
      ? this.util.getSourceTypesForTarget(type.toLowerCase(), GlobalConstants.paramMappDataTyp)
      : GlobalConstants.paramMappDataTyp[type.toLowerCase()];
    const targFlds = this.allFields.filter(
      (f) =>
        f?.type !== 'pageVariable' &&
        !f.fkId &&
        !this.util.isRestrictedFieldByConstants(targetRestrictionConst, f) &&
        validTypes?.includes(f.f_type.toLowerCase()) &&
        f.name?.toLowerCase().includes(query.toLowerCase())
    );
    const filterFields = this.util.filterFieldsBasedOnConstants(
      targetRestrictionConst,
      targFlds
    );
    const filterpgVars = this.allFields.filter(
      (f) =>
        f.type === 'pageVariable' &&
        !this.util.isRestrictedFieldByConstants(targetRestrictionConst, f) &&
        validTypes?.includes(f.f_type.toLowerCase()) &&
        f.name.toLowerCase().includes(query.toLowerCase())
    );
    let groupedFields: any = [];
    if (filterFields?.length) {
      groupedFields.push({
        name: this.translate.instant('TABLE_FIELDS'),
        items: filterFields
      });
    }
    if (this.allFields.find((f) => f.fkId)) {
      this.queryMapData?.groupedFields?.forEach((gf) => {
        if (gf.items?.length) {
          const items = gf.items.filter(
            (f) =>
              !this.util.isRestrictedFieldByConstants(targetRestrictionConst, f) &&
              validTypes?.includes(f.f_type.toLowerCase()) &&
              f.name.toLowerCase().includes(query.toLowerCase())
          );
          if (items?.length) {
            groupedFields.push({
              name: gf.label,
              items: items
            });
          }
        }
      });
    }
    if (filterpgVars?.length) {
      groupedFields.push({
        name: this.translate.instant('PAGE_VARIABLES'),
        items: filterpgVars
      });
    }
    if (!groupedFields?.length) {
      this.allFieldsFiltered = [];
      groupedFields = [];
    }
    setTimeout(() => {
      if (this.element.lookupTo === 'navigatePageParams' && this.colHeader2 === 'VARTOLST') {
        this.allFieldsFiltered = [...filterpgVars];
      } else {
        this.allFieldsFiltered = [...groupedFields];
      }
    }, 0);
  }

  onValueChange(event) {
    setTimeout(() => {
      this.set();
    }, 100);
  }

  onAutoComValClear(data, fld) {
    if (!data[fld]) {
      this.util.showMessage(
        'error',
        this.translate.instant('MAP_ERR_MSG').replace('{elementTitle}', this.element.title)
      );
    }
  }

  /*
   On Loading the Param, get the fields which has been modified but saved in param mapping. This will happen in the concurrent case
  */
  checkUnSupportedFlds(lstfld, detFld): string {
    let message = '';
    // For parameterMapStdGrid/parameterMapStdGridPageVar/queryMapPageVar: lstfld (LHS) is TARGET, detFld (RHS) is SOURCE
    const isLhsTarget = this.element.lookupTo === 'parameterMapStdGrid' || this.element.lookupTo === 'parameterMapStdGridPageVar' || this.element.lookupTo === 'queryMapPageVar';
    const isIncompatible = isLhsTarget
      ? !this.util.getSourceTypesForTarget(lstfld?.f_type?.toLowerCase(), GlobalConstants.paramMappDataTyp)?.includes(detFld?.f_type?.toLowerCase())
      : !GlobalConstants.paramMappDataTyp[lstfld?.f_type?.toLowerCase()]?.includes(detFld?.f_type?.toLowerCase());
    if (isIncompatible) {
      this.leftFieldsforpageVariables += lstfld?.name + ',';
      this.rightFieldsforpageVariables += detFld?.name + ',';
    }
    if (
      !lstfld?.searchable &&
      this.techStackData?.textSearch === GlobalConstants.searchDbEs &&
      this.element.lookupTo === 'parameterMapStdGrid'
    ) {
      message += this.translate.instant('PARAM_SEARCH').replace('{field}', lstfld?.name);
    }
    return message;
  }

  /**
   * Handles the form mapping logic for parameters.
   *
   * - Extracts indexed fields, table fields, and page variables from the query map.
   * - Combines table fields and page variables based on the lookup type.
   * - If a default filter is present in the form data, makes an HTTP GET request to fetch query data.
   * - Parses the query data to extract filter fields and handles any errors.
   */
  formMappingForParams() {
    const isRdbmsSearch = this.techStackData?.textSearch === GlobalConstants.searchDbRdbms;
    const queryMapsub = this.store.select(queryMapData).subscribe((queryMap) => {
      if (queryMap) {
        this.queryMapData = cloneDeep(queryMap);
        this.indexedFields = queryMap.indexedFields;
        let curTblFields = queryMap.fields ? [...queryMap.fields] : [];
        const pgVars = queryMap.pageVariables;
        if (pgVars) {
          const srcPageVariables = pgVars?.map((pv) => {
            return this.getPageVarObject(pv);
          });
          curTblFields = [...curTblFields, ...srcPageVariables];
        }
        if (
          this.element.lookupTo === 'detailPageParameters' ||
          this.element.lookupTo === 'parameterMapHoldValParams' ||
          this.element.lookupTo === 'navigatePageParams'
        ) {
          this.srcAllFlds = [...curTblFields];
          if (queryMap?.referredTableFields) {
            this.srcAllFlds = [...this.srcAllFlds, ...queryMap.referredTableFields];
          }
          if (queryMap?.referredSrcTableFields) {
            this.srcAllFlds = [...this.srcAllFlds, ...queryMap.referredSrcTableFields];
          }
        } else {
          this.allFields = [...curTblFields];
        }
        this.handleFormMappingLogic(queryMap, isRdbmsSearch);
      }
    });
    this.addToSubscriptionsList(queryMapsub);
    if (this.formData?.defaultFilter) {
      const url = `${ environment.apihost}/${ApiConstants.getQuery.url}${this.formData.defaultFilter
        }/${this.appGlobalService.get('appId')}`;
      const qbObjSub = this.http.get(url).subscribe({
        next: (qbVal: any) => {
          try {
            const rules = JSON.parse(qbVal.query).rules;
            this.filterFields = rules.map((r) => r?.lhs?.fieldId);
          } catch (e) {
            console.error(e);
          }
        },
        error: (err: any) => {
          console.error(err);
        }
      });
      this.subscriptions.push(qbObjSub);
    }
  }

  getPageVarObject(pageVar) {
    return {
      type: 'pageVariable',
      sid: pageVar.sid,
      name: pageVar.name,
      f_type: GlobalConstants.pageVariableMap[pageVar.type],
      tableId: pageVar.tableSid,
      appId: pageVar.appId
    };
  }

  // Helper method to handle the main logic
  handleFormMappingLogic(queryMap: any, isRdbmsSearch: boolean) {
    const sourceFields =
      queryMap.dataGridFields || queryMap.detailPageFields || queryMap.queryViewFields || queryMap.navigatedPageFields;
    let otherTblFlds: any = [];
    if (sourceFields && sourceFields.length) {
      this.isLoading = false;
      otherTblFlds = cloneDeep(
        this.util.filterFieldsBasedOnConstants(
          this.element.lookupTo == 'parameterMapStdGrid' ? this.getSourceFieldRestrictionConstant() : 'sourceFields',
          sourceFields
        )
      );
      if (this.element.lookupTo == 'parameterMapStdGrid' && queryMap?.referredTableFields) {
        otherTblFlds = [...otherTblFlds, ...cloneDeep(queryMap.referredTableFields)];
      }
      if (queryMap?.searchableFields && !isRdbmsSearch && this.element?.lookupTo == 'parameterMapStdGrid') {
        otherTblFlds.forEach((s) => {
          s.searchable = queryMap?.searchableFields?.includes(s.sid);
        });
      }
    }
    const pgVars =
      queryMap.queryViewPageVariables ||
      queryMap.dataGridPageVariables ||
      queryMap.detailPageVariables ||
      queryMap.navigatedPageVariables;
    if (pgVars) {
      const srcPageVariables = pgVars?.map((pv) => {
        return this.getPageVarObject(pv);
      });
      otherTblFlds = [...otherTblFlds, ...srcPageVariables];
    }
    if (
      this.element.lookupTo === 'detailPageParameters' ||
      this.element.lookupTo === 'parameterMapHoldValParams' ||
      this.element.lookupTo === 'navigatePageParams'
    ) {
      this.allFields = [...otherTblFlds];
      if (queryMap?.referredDetTableFields) {
        this.allFields = [...this.allFields, ...queryMap.referredDetTableFields];
      }
    } else {
      this.srcAllFlds = [...otherTblFlds];
    }
    // Continue with backup logic. Only mark data ready and validate once the source
    if (sourceFields && sourceFields.length) {
      this.isStoreDataReady = true;
      if (this.backupVal?.length) {
        this.processBackupValues();
      }
    }
  }

  /**
   * Returns true only when the loaded field array contains at least one field that
   * belongs to the same table as the given saved field.
   */
  private fieldArrayHasTable(fieldArray: any[], savedField: any): boolean {
    const tableId = savedField?.tableId || savedField?.f_tableId;
    if (!tableId || !fieldArray?.length) {
      return false;
    }
    return fieldArray.some((f) => (f?.tableId || f?.f_tableId) === tableId);
  }

  private getSourceFieldRestrictionConstant(): 'paramMappingSource' | 'sourceFields' {
    // In ES mode, searchable metadata can be delayed or missing for some fields.
    // Use base source restrictions for visibility and enforce searchable on selection.
    return this.techStackData?.textSearch === GlobalConstants.searchDbEs ? 'sourceFields' : 'paramMappingSource';
  }

  // Helper method for processing backup values
  processBackupValues() {
    let message = '';
    let deletedIds: any[] = [];
    const targetFlds = this.util.filterFieldsBasedOnConstants(
      this.element.lookupTo === 'parameterMapStdGrid' || this.element.lookupTo === 'parameterMapStdGridPageVar'
        ? 'paramMappingTarget'
        : 'targetFields',
      this.allFields
    );
    let noLongerFields = '';
    this.parameterMapping = this.backupVal.map((p) => {
      const lf = this.srcAllFlds.find((f) => f.sid === p[this.srcKey]?.sid);
      const df = this.allFields.find((f) => f.sid === p[this.tarkey]?.sid);
      let mismatch = false;
      if (lf && df) {
        const result = this.checkUnSupportedFlds(lf, df);
        message += result;
      }
      // Only mark a field as deleted when the loaded field array actually contains
      // fields belonging to THAT field's own table.
      if (!lf && p[this.srcKey]?.sid && this.fieldArrayHasTable(this.srcAllFlds, p[this.srcKey])) {
        deletedIds = [...deletedIds, p[this.srcKey]?.sid];
      }
      if (!df && p[this.tarkey]?.sid && this.fieldArrayHasTable(this.allFields, p[this.tarkey])) {
        deletedIds = [...deletedIds, p[this.tarkey]?.sid];
      }
      if(this.leftFieldsforpageVariables && this.rightFieldsforpageVariables){
          this.typeMisMatchMessageforpageVariables = this.translate.instant('PARAM_FLD_TYP')
          .replace('{field1}', this.leftFieldsforpageVariables.slice(0, -1))
          .replace('{field2}', this.rightFieldsforpageVariables.slice(0, -1));
        this.leftFieldsforpageVariables = '';
        this.rightFieldsforpageVariables = '';
      }
      return {
        ...p,
        ...{
          [this.srcKey]: lf ? lf : { sid: p[this.srcKey]?.sid || null, name: p[this.srcKey]?.name || '' },
          [this.tarkey]: df ? df : { sid: p[this.tarkey]?.sid || null, name: p[this.tarkey]?.name || '' },
        },
        sid: uuidv4()
      };
    });
    this.allFields = [...targetFlds];
    this.backupVal = cloneDeep(this.parameterMapping);

    if (deletedIds.length) {
      this.handleDeletedIds(deletedIds, "");
    }
    if(this.typeMisMatchMessageforpageVariables || message){
      this.confirmationDialogService.confirm({
        message: message + this.typeMisMatchMessageforpageVariables,
        acceptLabel: String(this.translate.instant('OK')),
        accept: () => {
          /* empty */
        },
        rejectVisible: false
      });
    }
  }

  // Helper method to handle deleted IDs
  handleDeletedIds(deletedIds: string[], message: string) {
    this.isLoading = true;
    deletedIds.forEach((id, i) => {
      const lookUpTypes = ['detailPageParameters', 'parameterMapStdGrid'];
      const idSub = this.baseService.get(ApiConstants.getDeletedRecord, { sid: id }).subscribe({
        next: (res: any) => {
          message += this.translate
            .instant(lookUpTypes.includes(this.element.lookupTo) ? 'PARAM_DEL' : 'PARAM_DEL_HOLD_VAL')
            .replace('{field}', res?.name);
          const pMap = this.parameterMapping.map((p: any) => {
            if (p[this.srcKey]?.sid === id) {
              p[this.srcKey] = res;
            }
            if (p[this.tarkey]?.sid === id) {
              p[this.tarkey] = res;
            }
            return p;
          });
          this.parameterMapping = pMap;
          if (i === deletedIds.length - 1) {
            this.isLoading = false;
            this.confirmationDialogService.confirm({
              message,
              acceptLabel: String(this.translate.instant('OK')),
              accept: () => {
                /* empty */
              },
              rejectVisible: false
            });
          }
        },
        error: (err: any) => {
          this.isLoading = false;
        }
      });
      this.addToSubscriptionsList(idSub);
    });
  }

  setMapping(valueToSend) {
    const validMaps = cloneDeep(this[valueToSend].filter((p) => p[this.srcKey] && p[this.tarkey]));
    /*
      name, f_type in list field, detail field should not be sent
      sid in each row should not be sent
    */
    const mapps = validMaps
      .filter((p) => p[this.srcKey] && p[this.tarkey])
      .map((m) => {
        let lf, df;
        lf = {
          sid: m[this.srcKey].sid,
          tableId: m[this.srcKey].tableId ? m[this.srcKey].tableId : m[this.srcKey].f_tableId,
          appId: m[this.srcKey].appId,
          type: m[this.srcKey].type == 'pageVariable' ? m[this.srcKey].type : 'field'
        };
        df = {
          sid: m[this.tarkey].sid,
          tableId: m[this.tarkey].tableId ? m[this.tarkey].tableId : m[this.tarkey].f_tableId, //
          appId: m[this.tarkey].appId,
          type: m[this.tarkey].type == 'pageVariable' ? m[this.tarkey].type : 'field'
        };
        const listFldInfo = this.srcAllFlds.find((f) => f.sid == m[this.srcKey]?.sid);
        const detFldInfo = this.allFields.find((f) => f.sid == m[this.tarkey]?.sid);
        if (listFldInfo?.fkTableSid) {
          lf = {
            ...lf,
            fkTableSid: listFldInfo?.fkTableSid,
            fkId: listFldInfo?.fkId,
            fkAppId: listFldInfo?.aid
          };
        }
        if (detFldInfo?.fkTableSid) {
          df = {
            ...df,
            fkTableSid: listFldInfo?.fkTableSid,
            fkId: listFldInfo?.fkId,
            fkAppId: listFldInfo?.aid
          };
        }
        if (Object.prototype.hasOwnProperty.call(m, 'sid')) {
          delete m.sid;
        }
        return {
          ...m,
          ...{
            [this.srcKey]: lf,
            [this.tarkey]: df
          }
        };
      });
    this.backupVal = cloneDeep(this[valueToSend].filter((p) => p[this.srcKey] && p[this.tarkey]));
    this.onChange(mapps?.length ? mapps : null);
    console.log(mapps);
  }

  updateParamInMapping(param) {
    const mapping = this.parameterMapping.map((m) => {
      return m.sid === param.sid ? param : m;
    });
    this.parameterMapping = [...mapping];
  }

  onSrcFieldSel(value, param) {
    if (
      value?.searchable === false &&
      this.techStackData?.textSearch === GlobalConstants.searchDbEs &&
      this.element?.name === 'parameterMapping'
    ) {
      param[this.srcKey] = null; // Clear the specific key

      this.parameterMapping = this.parameterMapping.map(
        (m) => (m.sid === param.sid ? { ...m, ...param } : m) // Create a new object with updated values
      );
      return;
    }
    // time out is required so that value value will be properly binded to parameter mapping
    setTimeout(() => {
      const sameListMaps = this.parameterMapping.filter((p) => p[this.srcKey]?.sid === value?.sid);
      const backupFld = this.backupVal.find((p) => p?.sid === param?.sid)?.[this.srcKey];
      let err = false;
      if (sameListMaps.length > 1) {
        err = true;
        this.util.showMessage(
          'error',
          this.translate
            .instant('LIST_FLD_ERR')
            .replace('{field}', value?.name)
            .replace('{elementTitle}', this.element.title)
        );
      }
      if (this.element.lookupTo === 'parameterMapStdGrid' && this.filterFields.includes(value?.sid)) {
        err = true;
        this.util.showMessage('error', this.translate.instant('LIST_DEF_ERR').replace('{field}', value?.name));
      }
      if (err) {
        param = { ...param, ...{ [this.srcKey]: backupFld ? backupFld : null } };
        this.updateParamInMapping(param);
        return;
      }
      param = { ...param, ...{ [this.tarkey]: null } };
      const fld = this.srcAllFlds.find((f) => f.sid === value?.sid);
      if (
        ((fld?.sysGen || fld?.f_formula) && this.element.lookupTo === 'parameterMapStdGrid') ||
        this.element.lookupTo === 'parameterMapStdGridPageVar'
      ) {
        param = { ...param, ...{ holdFilterValue: false } };
      }
      this.updateParamInMapping(param);
    }, 100);
  }

  onTargetFieldSel(value, param) {
    // time out is required so that value will be properly binded to parameter mapping
    setTimeout(() => {
      const sameDetailMaps = this.parameterMapping.filter((p) => p[this.tarkey]?.sid === value?.sid);
      try {
        const backupFld = this.backupVal.find(
          (p) => p && p?.sid === param.sid && p[this.tarkey]?.f_type === param[this.srcKey]?.f_type
        )?.[this.tarkey];

        if (sameDetailMaps.length > 1) {
          this.util.showMessage(
            'error',
            this.translate
              .instant('LIST_FLD_ERR')
              .replace('{field}', value?.name)
              .replace('{elementTitle}', this.element.title)
          );
          param = { ...param, ...{ [this.tarkey]: backupFld ? backupFld : null } };
          this.updateParamInMapping(param);
          return;
        }
        this.setMapping('parameterMapping');
      } catch (e) {
        console.log(e);
      }
    }, 100);
  }

  addParam() {
    const pageVariables = this.srcAllFlds.filter((fld) => fld?.type === 'pageVariable');
    if (
      (this.element.lookupTo === 'parameterMapStdGridPageVar' || this.element.lookupTo === 'queryMapPageVar') &&
      pageVariables.length === 0
    ) {
      this.util.showMessage('error', this.translate.instant('NO_PAGE_VAR'));
    } else {
      const len = this.parameterMapping.length;
      if (len > 0) {
        if (!this.parameterMapping[len - 1][this.srcKey] || !this.parameterMapping[len - 1][this.tarkey]) {
          this.util.showMessage(
            'error',
            this.translate.instant('MAP_ERR_MSG').replace('{elementTitle}', this.element.title)
          );
          return;
        }
      }
      let paramMap = {
        [this.srcKey]: null,
        [this.tarkey]: null,
        sid: uuidv4()
      };
      if (this.element.lookupTo === 'parameterMapStdGrid') {
        paramMap = {
          ...paramMap,
          ...{
            holdFilterValue: true,
            viewInPages: false
          }
        };
      }
      this.parameterMapping = [...this.parameterMapping, paramMap];
    }
  }

  openOption(data) {
    let fld;
    if (this.element.lookupTo === 'queryMapMandParams') {
      this.showQueryFilterOptions = true;
      fld = this.ptFields.find((f: any) => f.sid === data.lookupField?.sid);
    } else {
      this.viewInPages = data.viewInPages;
      this.showFilterOptions = true;
      fld = this.srcAllFlds.find((f) => f.sid === data.listField?.sid);
    }
    this.holdFilterValue = data.holdFilterValue;
    this.selectedParam = data;
    this.holdValDis = (fld.sysGen || fld.f_formula) && !this.holdFilterValue;
  }

  updateOption(event) {
    this.selectedParam = {
      ...this.selectedParam,
      ...{
        holdFilterValue: this.holdFilterValue
      }
    };
    let fld;
    if (this.element.lookupTo === 'parameterMapStdGrid' || this.element.lookupTo === 'parameterMapHoldValParams') {
      this.selectedParam = {
        ...this.selectedParam,
        ...{
          viewInPages: this.viewInPages
        }
      };
      const params = this.parameterMapping.map((d) => {
        return d?.listField?.sid === this.selectedParam?.listField?.sid ? this.selectedParam : d;
      });
      this.parameterMapping = [...params];
      this.setMapping('parameterMapping');
      fld = this.srcAllFlds.find((f) => f.sid === this.selectedParam.listField?.sid);
    } else {
      const queryMap = this.queryMapping.map((d) => {
        return d?.lookupField?.sid === this.selectedParam?.lookupField?.sid ? this.selectedParam : d;
      });
      this.queryMapping = [...queryMap];
      this.set();
      fld = this.ptFields.find((f: any) => f.sid === this.selectedParam.lookupField?.sid);
    }
    /*
      Disable the hold filter immediately for the formula fields once it is set to false
    */
    this.holdValDis = (fld.sysGen || fld.f_formula) && !this.holdFilterValue;
  }

  deleteOptionConfirmation(ri) {
    const deleteCallback = () => {
      this.deleteOption(ri);
    };
    this.confirmationDialogService.confirm({
      message: this.translate.instant('CONFIRM_PAGE_MAPPING_DELETE'),
      accept: deleteCallback
    });
  }

  deleteOption(ri) {
    const mappng = cloneDeep(this.parameterMapping);
    mappng.splice(ri, 1);
    this.parameterMapping = [...mappng];
    this.setMapping('parameterMapping');
  }

  getSourceAndTargetScreens() {
    const srcScreen = this.allScreens.find((s: any) => s.sid === this.currentScreen.sid);
    const targScreen = this.allScreens.find((s: any) => s.sid === this.formData?.pageName?.sid);
    return {
      source: srcScreen,
      target: targScreen
    };
  }

  ngOnInit(): void {
    this.appId = this.appGlobalService.get('appId');
    this.metaInfo = this.appGlobalService.get('appmetaInfo');
    this.techStackData = this.techStackData || this.appGlobalService.get('technologyChoices');
    const metaInfoSub = this.store.select(metaInfo).subscribe((appmetaInfo: any) => {
      if (appmetaInfo) {
        this.metaInfo = cloneDeep(appmetaInfo);
      }
    });
    this.addToSubscriptionsList(metaInfoSub);
    switch (this.element.lookupTo) {
      case 'queryMapMandParams':
        if (this.element.name === 'queryViewMapping') {
          this.colHeader1 = 'LIST_PG_QRY_PARMS';
          this.colHeader2 = 'MAP_FROM_FIELD';
        } else if (this.element.name === 'detailPageMapping') {
          this.colHeader1 = 'DET_PG_QRY_PARMS';
          this.colHeader2 = 'FIELDS_IN_LIST';
        }
        this.srcKey = 'lookupField';
        this.tarkey = 'tableField';
        this.formMapping();
        break;
      case 'queryMapDetParams':
        this.srcKey = 'lookupField';
        this.tarkey = 'tableField';
        this.colHeader1 = 'DETAIL_PG_FIELDS';
        this.colHeader2 = 'FIELDS_IN_LIST';
        this.btnName = 'ADD';
        this.formMapping();
        break;
      case 'parameterMapStdGrid':
      case 'parameterMapHoldValParams':
      case 'parameterMapStdGridPageVar':
      case 'detailPageParameters':
        if (this.element.lookupTo === 'parameterMapStdGridPageVar') {
          this.colHeader1 = 'PAGE_VARIABLES_IN_LIST';
          this.btnName = 'ADD_PAGE_VAR';
        } else {
          this.colHeader1 = this.element.lookupTo === 'parameterMapStdGrid' ? 'FIELDS_ONLY_IN_LIST' : 'FIELDS_IN_LIST';
          this.btnName = this.element.lookupTo === 'parameterMapStdGrid' ? 'ADD_PARAM' : 'ADD';
        }
        this.colHeader2 = 'FIELDS_IN_DETAIL';
        this.srcKey = 'listField';
        this.tarkey = 'detailField';
        this.formMappingForParams();
        break;
      case 'navigatePageParams': {
        const scrInfo: any = this.getSourceAndTargetScreens();
        this.colHeader1 = scrInfo?.source?.pageType === 'list' ? 'VARFRMLST' : 'VARFRMDET';
        this.colHeader2 = scrInfo?.target?.pageType === 'list' ? 'VARTOLST' : 'VARTODET';
        this.srcKey = 'sourceKey';
        this.tarkey = 'targetKey';
        this.btnName = 'ADD';
        this.formMappingForParams();
        break;
      }
      case 'queryMapPageVar':
        this.colHeader1 = 'PAGE_VARIABLES';
        this.colHeader2 = 'FIELDS_IN_DETAIL';
        this.btnName = 'ADD_PAGE_VAR';
        this.srcKey = 'lookupField';
        this.tarkey = 'tableField';
        this.formMappingForParams();
        break;
      default:
        break;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    const nextContextKey = this.getContextKey();
    if (this.activeContextKey && this.activeContextKey !== nextContextKey) {
      this.clearRuntimeState();
    }
    this.activeContextKey = nextContextKey;

    if (changes.formData) {
      const formDataChangeHistory = changes.formData;

      if (
        formDataChangeHistory.previousValue?.detailPage?.sid !== formDataChangeHistory.currentValue?.detailPage?.sid
      ) {
        // Refech the detail page fields whenever there is a change in the detail page selection
        if (this.formData?.detailPage?.sid) {
          // this.getFieldsOfDetailPageDataModel();
        }
      }
    }
  }

  ngOnDestroy(): void {
    this.clearRuntimeState();
    this.store.dispatch(setQueryMapData({ queryMapData: null }));
  }
}



